import { z } from "zod";

export type CheckGuestPhoneNumberResponse = z.infer<typeof CheckGuestPhoneNumberResponseSchema>;
export const CheckGuestPhoneNumberResponseSchema = z.object({
  isAvailable: z.boolean(),
});
